import React, {useState, useMemo, useEffect} from 'react';
import {useTable, useRowSelect} from 'react-table';
import {ContentWrapper, Button, Input} from '@components';
import moment from 'moment';
// import { useParams } from 'react-router-dom';
import Select from 'react-select';
import {useHistory, useParams} from 'react-router-dom';
import Modal from 'react-modal';
import toast from 'react-hot-toast';
import {useMutation} from 'react-query';
import {ReactComponent as User} from '@images/user.svg';
import {
  awardManage,
  getProducts,
  getShopUsersDetail,
  getShopUsersMoneySpents,
  addMountSpentApi,
  getShopUsersPurchases,
  getShopUsersMoneySpentsBonus,
  giveBonusesApi,
  getShopUsersEarned,
  getShopUsersGifts,
  delShopUserApi,
  Acceptapi,
  getSingleUserPointList,
  changeRewardStatus,
  changeGiftStatus,
  ProductPurchaseNew,
  showPurchaseStatusChangeSuccessToast,
} from '@apis';
import {getFCP} from 'web-vitals';
import debby from '@images/debby.png';
import axios from 'axios';
import {API_HOST} from '@apis/';
import './users.css';
import {map} from 'lodash';
import {languageToAcceptLanguage} from '@constants/languages';
import {useTranslation} from 'react-i18next';
import i18n from '../../i18n';
import {getLocalizedAwardType} from '../../utils/multilingual';
import {getAbsoluteImageUrl} from '../../utils/imageUtils';

// Dynamic token getter function
const getAuthToken = () =>
  localStorage.getItem('nls:auth') || sessionStorage.getItem('nls:auth');

const getApiHeaders = (extra = {}) => ({
  'Accept-Language': languageToAcceptLanguage(i18n.language),
  Authorization: `Token ${getAuthToken()}`,
  ...extra,
});

const IndeterminateCheckbox = React.forwardRef(
  ({indeterminate, ...rest}, ref) => {
    const defaultRef = React.useRef();
    const resolvedRef = ref || defaultRef;

    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);

    return (
      <>
        <input type="checkbox" ref={resolvedRef} {...rest} />
      </>
    );
  },
);
const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '30%',
  },
};
const Table = ({columns, data}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    selectedFlatRows,
    state: {selectedRowIds},
  } = useTable({columns, data}, useRowSelect, hooks => {
    hooks.visibleColumns.push(columns => [
      {
        id: 'selection',
        Header: ({getToggleAllRowsSelectedProps}) => (
          <div>
            <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
          </div>
        ),
        Cell: ({row}) => (
          <div>
            <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
          </div>
        ),
      },
      ...columns,
    ]);
  });

  return (
    <table {...getTableProps()} className="min-w-full">
      <thead className="bg-tableHeaderBg p-4">
        {headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map(column => (
              <th
                {...column.getHeaderProps()}
                className="text-left text-menu font-normal uppercase text-sm px-4 py-2">
                {column.render('Header')}
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map(row => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps()}>
              {row.cells.map(cell => {
                return (
                  <td
                    {...cell.getCellProps()}
                    className="p-4 whitespace-nowrap text-sm">
                    {cell.render('Cell')}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

const ShopUserDetail = props => {
  const {t} = useTranslation();

  const {id} = useParams();

  const [acceptearn, setacceptearnData] = useState([]);
  const [rejectearn, setrejectearnData] = useState([]);
  const [acceptpurchase, setacceptpurchaseData] = useState([]);
  const [rejectpurchase, setrejectpurchaseData] = useState([]);
  const [moneyspent, setMoneySpent] = useState('');
  const [discount, setDiscount] = useState('');
  const [points, setPoint] = useState(0);
  const [gift, setGift] = useState(0);
  const [amount, setAmount] = useState('');
  const [note, setNote] = useState('');
  const [modalIsOpen, setIsOpen] = useState(false);
  const [bonusmodalIsOpen, setbonusIsOpen] = useState(false);
  const [data, setData] = useState([]);
  const [spendData, setSpentData] = useState([]);
  const [spendbonusData, setSpentBonusData] = useState([]);
  const [PurchaseData, setPurchaseData] = useState([]);
  const [GiftData, setGiftData] = useState([]);
  const [RewardData, setRewardData] = useState([]);
  const [userdata, setUserData] = useState([]);
  const [columns, setColumn] = useState('1');
  const [loading, setLoading] = useState(false);
  const [productoption, setProductOption] = useState([]);
  const [refresh, setRefresh] = useState(false);

  // Add specific loading states to prevent visual jumps
  const [userProfileLoading, setUserProfileLoading] = useState(true);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);

  //Pagination
  const [rewardCurrentPage, setRewardCurrentPage] = useState(1);
  const [giftCurrentPage, setGiftCurrentPage] = useState(1);
  const [purchaseCurrentPage, setPurchaseCurrentPage] = useState(1);
  const [moneyCurrentPage, setMoneyCurrentPage] = useState(1);
  const [rewardNextPage, setRewardNextPage] = useState('');
  const [rewardpreviousPage, setRewardPreviousPage] = useState('');
  const [giftNextPage, setGiftNextPage] = useState('');
  const [giftpreviousPage, setGiftPreviousPage] = useState('');
  const [purchaseNextPage, setPurchaseNextPage] = useState('');
  const [purchasepreviousPage, setPurchasePreviousPage] = useState('');
  const [moneyNextPage, setMoneyNextPage] = useState('');
  const [moneypreviousPage, setMoneyPreviousPage] = useState('');
  const [rewardTotal, setRewardTotal] = useState(0);
  const [giftTotal, setGiftTotal] = useState(0);
  const [purchaseTotal, setPurchaseTotal] = useState(0);
  const [moneyTotal, setMoneyTotal] = useState(0);

  // const product
  const getUsers = async () => {
    let config = {
      url: API_HOST + `/admin-api/v1/shop-users/}`,
      //      url: API_HOST + '/admin-api/v1/shop-users/?page=${pageNumber}',
      method: 'get',
      headers: getApiHeaders(),
    };
    await axios(config)
      .then(res => res)
      .then(res => console.log(''));
  };

  useEffect(() => {
    (async () => {
      var config = {
        url:
          API_HOST +
          `/admin-api/v1/shop-users/${
            props.params
          }/reward-list/?page=${rewardCurrentPage}`,
        method: 'get',
        headers: getApiHeaders({'content-type': 'application/json'}),
      };
      let data = await axios(config).then(res => {
        if (res?.data?.results.length > 0) {
          let resu = res?.data?.results.map(e => {
            let points = 0;

            if (
              e.level_award.points !== undefined &&
              e.level_award.points !== null
            ) {
              points = e.level_award.points;
            }

            let gift = 0;
            if (
              e.level_award.gift !== undefined &&
              e.level_award.gift !== null
            ) {
              gift = e.level_award.gift;
            }

            let data_point = points != 0 ? `${points} Points` : '';

            let data_gift = gift != 0 ? `${gift} Gifts` : '';

            let text1 = data_point;
            let text2 = data_gift;
            let result = text1.concat(' ', text2);

            e.gift_oue = result;

            return e;
          });
          setRewardTotal(res.data.count);
          setRewardNextPage(res.data.next);
          setRewardPreviousPage(res.data.previous);
          setRewardData(resu);
        }
      });

      if (props.params) {
        // This API call was unused - removed to clean up code
        // If getSingleUserPointList is needed, it should be integrated into the main fetchData function
      }
    })();
  }, [props, refresh, rewardCurrentPage]);

  useEffect(() => {
    (async () => {
      const awardManageresult = await awardManage();

      let resData = [];

      if (awardManageresult.length > 0) {
        awardManageresult.map(e => {
          if (e.awards.length > 0) {
            e.awards.map(i => {
              resData.push({
                label:
                  getLocalizedAwardType(i) ||
                  i.award_type_display ||
                  'No award type',
                value: i.id,
              });
            });
          }
        });
      }

      setProductOption(resData);
    })();
  }, [setProductOption]);

  //const awardManageresult = await awardManage();

  const getUserDetails = () => {
    fetch(API_HOST + `/admin-api/v1/shop-users/${props.params}/user-balance/`, {
      method: 'GET',
      headers: getApiHeaders({'Content-Type': 'application/json'}),
    })
      .then(response => response.json())
      .then(function (data) {
        // Merge with existing data instead of overwriting to preserve transaction data
        setUserData(prevUserData => {
          if (
            !prevUserData ||
            Object.keys(prevUserData).length === 0 ||
            Array.isArray(prevUserData)
          ) {
            return data;
          }

          // Merge while preserving profile information from user-balance API
          return {
            ...prevUserData, // Keep existing transaction data
            ...data, // Add/update profile data
            user: {
              ...(prevUserData.user || {}),
              ...(data.user || {}),
              profile: {
                ...(prevUserData.user?.profile || {}),
                ...(data.user?.profile || {}),
              },
            },
          };
        });
      })
      .catch(e => {
        console.log('Error fetching user details:', e);
        // Don't overwrite existing data on error, just log it
      });
  };

  const getUserMoneySpent = () => {
    var config = {
      url:
        API_HOST +
        `/admin-api/v1/shop-users/${
          props.params
        }/money-spents/?page=${moneyCurrentPage}`,
      method: 'get',
      headers: getApiHeaders({'content-type': 'multipart/form-data'}),
    };

    axios(config)
      .then(res => {
        setMoneyTotal(res.data.count);
        setMoneyNextPage(res.data.next);
        setMoneyPreviousPage(res.data.previous);
        setSpentData(res.data.results);
      })
      .catch(err => console.log('errr', err));
  };

  const getUserGifts = () => {
    var config = {
      url:
        API_HOST +
        `/admin-api/v1/shop-users/${
          props.params
        }/gifts/?page=${giftCurrentPage}`,
      method: 'get',
      headers: getApiHeaders({'content-type': 'multipart/form-data'}),
    };

    axios(config)
      .then(res => {
        setGiftTotal(res.data.count);
        setGiftNextPage(res.data.next);
        setGiftPreviousPage(res.data.previous);
        setGiftData(res.data.results);
      })
      .catch(err => console.log('errr', err));
  };

  const getUserPurchases = () => {
    var config = {
      url:
        API_HOST +
        `/admin-api/v1/shop-users/${
          props.params
        }/product-purchases/?page=${purchaseCurrentPage}`,
      method: 'get',
      headers: getApiHeaders({'content-type': 'multipart/form-data'}),
    };
    axios(config).then(res => {
      setPurchaseTotal(res.data.count);
      setPurchaseNextPage(res.data.next);
      setPurchasePreviousPage(res.data.previous);
      setPurchaseData(res.data.results);
    });
  };

  // Separate function to load user profile data first (for immediate UI rendering)
  const loadUserProfile = async () => {
    setUserProfileLoading(true);

    try {
      // Use user-balance API as primary source since it contains all needed data
      const userDetailsData = await fetch(
        API_HOST + `/admin-api/v1/shop-users/${props.params}/user-balance/`,
        {
          method: 'GET',
          headers: getApiHeaders({'Content-Type': 'application/json'}),
        },
      )
        .then(response => {
          console.log('User-balance API response status:', response.status);

          // Check if response is actually JSON, not HTML
          const contentType = response.headers.get('content-type');
          if (
            response.ok &&
            contentType &&
            contentType.includes('application/json')
          ) {
            return response.json();
          } else {
            console.warn('User-balance API failed:');
            console.warn('- Status:', response.status);
            console.warn('- Content-Type:', contentType);
            return null;
          }
        })
        .catch(e => {
          console.log('Error fetching user balance data:', e);
          return null;
        });

      // Try to get basic user data as fallback
      let basicUserData = null;
      try {
        const resp = await getShopUsersDetail(props.params);
        if (
          resp &&
          typeof resp === 'object' &&
          !resp.includes &&
          !resp.charAt
        ) {
          // It's a valid object, not HTML string
          basicUserData = resp;
        } else {
          console.warn('getShopUsersDetail returned HTML, skipping...');
        }
      } catch (e) {
        console.warn(
          'getShopUsersDetail failed, using user-balance data only:',
          e,
        );
      }

      // Merge user data and set immediately for UI rendering
      let mergedUserData = {};

      if (
        userDetailsData &&
        typeof userDetailsData === 'object' &&
        Object.keys(userDetailsData).length > 0
      ) {
        console.log(
          'Using user-balance data as primary source:',
          userDetailsData,
        );

        mergedUserData = {...userDetailsData};

        if (basicUserData && typeof basicUserData === 'object') {
          mergedUserData.user = {
            ...(basicUserData.user || {}),
            ...(userDetailsData.user || {}),
          };

          if (userDetailsData.user?.profile || basicUserData.user?.profile) {
            mergedUserData.user.profile = {
              ...(basicUserData.user?.profile || {}),
              ...(userDetailsData.user?.profile || {}),
            };
          }
        }
      } else {
        console.log(
          'No valid user-balance data available, falling back to basic user data',
        );
        if (basicUserData && typeof basicUserData === 'object') {
          mergedUserData = basicUserData;
        } else {
          console.warn('No valid user data available from either source');
          mergedUserData = {};
        }
      }

      setUserData(mergedUserData);
      setUserProfileLoading(false);

      return mergedUserData;
    } catch (error) {
      console.error('Error loading user profile:', error);
      setUserProfileLoading(false);
      return null;
    }
  };

  const fetchData = async () => {
    setLoading(true);

    try {
      // If user profile isn't loaded yet, load it first
      if (!initialDataLoaded) {
        await loadUserProfile();
        setInitialDataLoaded(true);
      }

      const pro = await getProducts();
      const spentAmount = await getShopUsersMoneySpents(props.params);
      const PurchasedData = await getShopUsersPurchases(props.params);
      const rewardData = await getShopUsersEarned(props.params);
      const giftData = await getShopUsersGifts(props.params);

      // Agregar log para ver los datos de la request a level-awards
      console.log('Datos de level-awards:', rewardData);

      var acceptreward_earned = [];
      var rejectreward_earned = [];
      var acceptreward_purchased = [];
      var rejectreward_purchased = [];

      if (rewardData.results.length > 0) {
        for (var i = 0; i < rewardData.results.length; i++) {
          rewardData.results[i].user.rewardid = rewardData.results[i].id;
          if (rewardData.results[i].accepted == false) {
            rejectreward_earned.push(rewardData.results[i]);
          } else if (rewardData.results[i].accepted == true) {
            acceptreward_earned.push(rewardData.results[i]);
          }
        }
      }
      if (PurchasedData.results.length > 0) {
        for (var j = 0; j < PurchasedData.results.length; j++) {
          PurchasedData.results[j].user.rewardid = PurchasedData.results[j].id;
          if (PurchasedData.results[j].accepted == false) {
            rejectreward_purchased.push(PurchasedData.results[j]);
          } else if (PurchasedData.results[j].accepted == true) {
            acceptreward_purchased.push(PurchasedData.results[j]);
          }
        }
      }
      if (giftData && giftData.results.length > 0) {
        setGiftData(giftData.results);
      } else {
        setGiftData([]);
      }

      setacceptearnData(acceptreward_earned);
      setrejectearnData(rejectreward_earned);
      setacceptpurchaseData(acceptreward_purchased);
      setrejectpurchaseData(rejectreward_purchased);

      // Note: RewardData is handled by separate useEffect, don't overwrite here
      setSpentData(spentAmount.results);
      setPurchaseData(PurchasedData.results);

      setLoading(false);
    } catch (error) {
      console.error('Error in fetchData:', error);
      setLoading(false);
    }
  };
  const Acceptslected = async () => {
    setRewardData(acceptearn);
    setPurchaseData(acceptpurchase);
  };
  const Rejectslected = async () => {
    setRewardData(rejectearn);
    setPurchaseData(rejectpurchase);
  };
  const closebonusModal = async () => {
    setbonusIsOpen(false);
  };
  const openbonusModal = async () => {
    setbonusIsOpen(true);
  };
  const openModal = async () => {
    setIsOpen(true);
  };
  const closeModal = async () => {
    setIsOpen(false);
  };
  const history = useHistory();
  const SubmitmoumtSpent = useMutation(params => addMountSpentApi(params));
  const MoneySpent = async e => {
    e.preventDefault();
    if (amount == '' || note == '') {
      toast.error(t('shopUserDetail.inputError'));
    } else {
      await SubmitmoumtSpent.mutateAsync({
        id: props.params,
        amount: amount,
        note: note,
      });
      setIsOpen(false);
    }
    fetchData();
    getUserDetails();
  };
  const Submitbonus = useMutation(params => giveBonusesApi(params));
  const GiveBouns = async e => {
    e.preventDefault();
    if (moneyspent == '') {
      toast.error(t('shopUserDetail.inputError'));
    } else {
      await Submitbonus.mutateAsync({
        id: props.params,
        money_spent: moneyspent,
        discount: discount === '' ? 0 : discount,
        points: points,
        gift: gift,
      });
      setbonusIsOpen(false);
    }
    fetchData();
    getUserDetails();
  };
  const DelShopUser = useMutation(params => delShopUserApi(params));
  const RemoveUser = async id => {
    await DelShopUser.mutateAsync(props.params);
    toast.success(t('shopUserDetail.userRemovedSuccessfully'));
    history.push('/shop-users');
  };

  const RewardAccept = useMutation(params => Acceptapi(params));

  const acceptEarn = async id => {
    var paramdata = {
      status: 'accepted',
    };

    let res = await changeRewardStatus(id.original.id, paramdata);

    if (res) {
      var config = {
        url: API_HOST + `/admin-api/v1/shop-users/${props.params}/reward-list/`,
        method: 'get',
        headers: getApiHeaders({'content-type': 'application/json'}),
      };
      let data = await axios(config).then(res => {
        if (res?.data?.results.length > 0) {
          let resu = res?.data?.results.map(e => {
            let points = 0;

            if (
              e.level_award.points !== undefined &&
              e.level_award.points !== null
            ) {
              points = e.level_award.points;
            }

            let gift = 0;
            if (
              e.level_award.gift !== undefined &&
              e.level_award.gift !== null
            ) {
              gift = e.level_award.gift;
            }

            let data_point = points != 0 ? `${points} Points` : '';

            let data_gift = gift != 0 ? `${gift} Gifts` : '';

            let text1 = data_point;
            let text2 = data_gift;
            let result = text1.concat(' ', text2);

            e.gift_oue = result;

            return e;
          });

          setRewardData(resu);
        }
      });
    }
    setTimeout(() => {
      setRefresh(!refresh);
    }, 1200);
    // setPurchaseData(purchasedData.results);
  };
  const rejectEarn = async id => {
    var paramdata = {
      status: 'rejected',
    };

    let res = await changeRewardStatus(id.original.id, paramdata);

    if (res) {
      var config = {
        url: API_HOST + `/admin-api/v1/shop-users/${props.params}/reward-list/`,
        method: 'get',
        headers: getApiHeaders({'content-type': 'application/json'}),
      };
      let data = await axios(config).then(res => {
        if (res?.data?.results.length > 0) {
          let resu = res?.data?.results.map(e => {
            let points = 0;

            if (
              e.level_award.points !== undefined &&
              e.level_award.points !== null
            ) {
              points = e.level_award.points;
            }

            let gift = 0;
            if (
              e.level_award.gift !== undefined &&
              e.level_award.gift !== null
            ) {
              gift = e.level_award.gift;
            }

            let data_point = points != 0 ? `${points} Points` : '';

            let data_gift = gift != 0 ? `${gift} Gifts` : '';

            let text1 = data_point;
            let text2 = data_gift;
            let result = text1.concat(' ', text2);

            e.gift_oue = result;

            return e;
          });

          setRewardData(resu);
        }
      });
    }
    setTimeout(() => {
      setRefresh(!refresh);
    }, 1200);
  };

  const acceptGift = async id => {
    var paramdata = {
      status: 'accepted',
    };

    let res = await changeGiftStatus(id.original.id, paramdata);

    if (res) {
      // var config = {
      //   url: API_HOST + `/admin-api/v1/shop-users/${props.params}/reward-list/`,
      //   method: 'get',
      //   headers: {
      //     'content-type': 'application/json',
      //     // 'cache-control': 'no-cache',
      //     Authorization: `Token ${auth_token}`,
      //   },
      // };
      // let data = await axios(config).then(res => {
      //   if (res?.data?.results.length > 0) {
      //     let resu = res?.data?.results.map(e => {
      //       let points = 0;

      //       if (
      //         e.level_award.points !== undefined &&
      //         e.level_award.points !== null
      //       ) {
      //         points = e.level_award.points;
      //       }

      //       let gift = 0;
      //       if (
      //         e.level_award.gift !== undefined &&
      //         e.level_award.gift !== null
      //       ) {
      //         gift = e.level_award.gift;
      //       }

      //       let data_point = points != 0 ? `${points} Points` : '';

      //       let data_gift = gift != 0 ? `${gift} Gifts` : '';

      //       let text1 = data_point;
      //       let text2 = data_gift;
      //       let result = text1.concat(' ', text2);

      //       e.gift_oue = result;

      //       return e;
      //     });

      //     setRewardData(resu);
      //   }
      // });
      getUserGifts();
    }
    setTimeout(() => {
      setRefresh(!refresh);
    }, 1200);
  };

  const rejectGift = async id => {
    var paramdata = {
      status: 'rejected',
    };

    let res = await changeGiftStatus(id.original.id, paramdata);

    if (res) {
      // var config = {
      //   url: API_HOST + `/admin-api/v1/shop-users/${props.params}/reward-list/`,
      //   method: 'get',
      //   headers: {
      //     'content-type': 'application/json',
      //     // 'cache-control': 'no-cache',
      //     Authorization: `Token ${auth_token}`,
      //   },
      // };
      // let data = await axios(config).then(res => {
      //   if (res?.data?.results.length > 0) {
      //     let resu = res?.data?.results.map(e => {
      //       let points = 0;

      //       if (
      //         e.level_award.points !== undefined &&
      //         e.level_award.points !== null
      //       ) {
      //         points = e.level_award.points;
      //       }

      //       let gift = 0;
      //       if (
      //         e.level_award.gift !== undefined &&
      //         e.level_award.gift !== null
      //       ) {
      //         gift = e.level_award.gift;
      //       }

      //       let data_point = points != 0 ? `${points} Points` : '';

      //       let data_gift = gift != 0 ? `${gift} Gifts` : '';

      //       let text1 = data_point;
      //       let text2 = data_gift;
      //       let result = text1.concat(' ', text2);

      //       e.gift_oue = result;

      //       return e;
      //     });

      //     setRewardData(resu);
      //   }
      // });
      getUserGifts();
    }
    setTimeout(() => {
      setRefresh(!refresh);
    }, 1200);
  };

  const giftgetdata = async val => {
    setGift(val.value);
  };

  const acceptPurchase = async row => {
    if (
      !row.original.points_charged_on_request &&
      row.original.points_paid > row.original.user_current_points
    ) {
      toast.error(t('shopUserDetail.insufficientPoints'));
      return;
    }
    try {
      await ProductPurchaseNew(row.original.id, {accepted: true});
      showPurchaseStatusChangeSuccessToast(true);
      fetchData();
      setTimeout(() => {
        setRefresh(!refresh);
      }, 1200);
    } catch (error) {
      toast.error(
        typeof error === 'string'
          ? error
          : t('approve.errorApprovingItems'),
      );
    }
  };

  const rejectPurchase = async row => {
    try {
      await ProductPurchaseNew(row.original.id, {accepted: false});
      showPurchaseStatusChangeSuccessToast(false);
      fetchData();
      setTimeout(() => {
        setRefresh(!refresh);
      }, 1200);
    } catch (error) {
      toast.error(
        typeof error === 'string'
          ? error
          : t('approve.errorRejectingItems'),
      );
    }
  };

  const tablerewardcolumns = useMemo(
    () => [
      {
        Header: t('shopUserDetail.user'),
        accessor: 'user',
        Cell: ({value}) => (
          <div className="flex items-center">
            <div>
              {value?.profile?.profile_image ? (
                <img
                  src={getAbsoluteImageUrl(value.profile.profile_image)}
                  className="user-avatar"
                  alt="User avatar"
                />
              ) : (
                <img
                  src="https://cdn-icons-png.flaticon.com/512/1077/1077063.png"
                  className="user-avatar"
                  alt="User avatar"
                />
              )}
            </div>
            <div className="px-4">
              <p className="text-left">
                {value.first_name} {value.last_name}
              </p>
            </div>
          </div>
        ),
      },
      {Header: t('shopUserDetail.received'), accessor: 'gift_oue'},
      {
        Header: t('shopUserDetail.details'),
        id: 'reward_details',
        Cell: ({row}) =>
          getLocalizedAwardType(row.original.level_award) ||
          row.original.code ||
          '',
      },
      // {Header: 'REWARD TYPE', accessor: 'reward_type'},
      {
        Header: t('shopUserDetail.status'),
        accessor: 'accepted',
        Cell: ({row}) => (
          <div className="inline-flex items-center">
            {row.original.status == 'pending' ? (
              <div className="inline-flex items-center">
                <Button
                  onClick={() => acceptEarn(row)}
                  label={t('shopUserDetail.accept')}
                  type="primary"
                />
                <Button
                  onClick={() => {
                    rejectEarn(row);
                  }}
                  label={t('shopUserDetail.reject')}
                  type="secondary"
                />
              </div>
            ) : row.original.status == 'accepted' ? (
              <div>{t('shopUserDetail.accepted')}</div>
            ) : (
              <div>{t('shopUserDetail.rejected')}</div>
            )}
          </div>
        ),
      },
    ],
    [t, i18n.language],
  );

  const tablegiftcolumns = useMemo(
    () => [
      {
        Header: t('shopUserDetail.user'),
        accessor: 'user',
        Cell: ({value}) => (
          <div className="flex items-center">
            <div>
              {value?.profile?.profile_image ? (
                <img
                  src={getAbsoluteImageUrl(value.profile.profile_image)}
                  className="user-avatar"
                  alt="User avatar"
                />
              ) : (
                <img
                  src="https://cdn-icons-png.flaticon.com/512/1077/1077063.png"
                  className="user-avatar"
                  alt="User avatar"
                />
              )}
            </div>
            <div className="px-4">
              <p className="text-left">
                {value.first_name} {value.last_name}
              </p>
            </div>
          </div>
        ),
      },
      {
        Header: 'Level',
        accessor: 'level',
        Cell: ({value}) => <div className="text-uppercase">{value}</div>,
      },
      {Header: t('shopUserDetail.details'), accessor: 'code'},
      {
        Header: t('shopUserDetail.date'),
        accessor: 'created_at',
        Cell: ({value}) => <div>{moment(value).format('MM-DD-YYYY')}</div>,
      },
      {
        Header: t('shopUserDetail.status'),
        accessor: 'accepted',
        Cell: ({row}) => (
          <div className="inline-flex items-center">
            {row.original.status == 'pending' ? (
              <div className="inline-flex items-center">
                <Button
                  onClick={() => acceptGift(row)}
                  label={t('shopUserDetail.accept')}
                  type="primary"
                />
                <Button
                  onClick={() => {
                    rejectGift(row);
                  }}
                  label={t('shopUserDetail.reject')}
                  type="secondary"
                />
              </div>
            ) : row.original.status == 'accepted' ? (
              <div>{t('shopUserDetail.accepted')}</div>
            ) : (
              <div>{t('shopUserDetail.rejected')}</div>
            )}
          </div>
        ),
      },
    ],
    [],
  );

  const tablepurchasecolumns = useMemo(
    () => [
      {
        Header: t('shopUserDetail.user'),
        accessor: 'user',
        Cell: ({value}) => (
          <div className="flex items-center">
            {value?.profile?.profile_image ? (
              <img
                src={getAbsoluteImageUrl(value.profile.profile_image)}
                className="user-avatar"
                alt="User avatar"
              />
            ) : (
              <img
                src="https://cdn-icons-png.flaticon.com/512/1077/1077063.png"
                className="user-avatar"
                alt="User avatar"
              />
            )}
            <div className="px-4">
              <p className="text-left">
                {value.first_name} {value.last_name}
              </p>
            </div>
          </div>
        ),
      },
      {Header: t('shopUserDetail.paid'), accessor: 'points_paid'},
      {
        Header: 'PURCHASED',
        accessor: 'product_name',
      },
      // {Header: 'PAID', accessor: 'points_paid'},
      // {Header: 'DATE', accessor: 'created_at'},
      {
        Header: t('shopUserDetail.status'),
        accessor: row => ({
          accepted: row.accepted,
          productId: row.product_id,
        }),
        Cell: ({row}) => (
          <div className="inline-flex items-center">
            {row.original.accepted == null ? (
              <div className="inline-flex items-center">
                <Button
                  onClick={() => acceptPurchase(row)}
                  label={t('shopUserDetail.accept')}
                  type="primary"
                />
                <Button
                  onClick={() => rejectPurchase(row)}
                  label={t('shopUserDetail.reject')}
                  type="secondary"
                />
              </div>
            ) : row.original.accepted == true ? (
              <div>{t('shopUserDetail.accepted')}</div>
            ) : (
              <div>{t('shopUserDetail.rejected')}</div>
            )}
          </div>
        ),
      },
    ],
    [],
  );

  const tablemoneysentcolumns = useMemo(
    () => [
      {
        Header: t('shopUserDetail.amountSpent'),
        accessor: 'amount',
      },
      {Header: 'DISCOUNT', accessor: 'discount'},
      {
        Header: 'DATE',
        accessor: 'created_at',
        Cell: ({value}) => (
          <div className="text-uppercase">
            {moment(value).format('MM-DD-YYYY')}
          </div>
        ),
      },
      {Header: t('shopUserDetail.note'), accessor: 'note'},
    ],
    [],
  );

  const tablemoneysentbounscolumns = useMemo(
    () => [
      // {
      //   Header: 'LEVEL',
      //   accessor: 'money_spent',
      // },
      {Header: 'DATE', accessor: 'created_at'},
      {Header: 'BONUS', accessor: 'gift_name'},
    ],
    [],
  );

  // Load user profile first on component mount for immediate UI rendering
  useEffect(() => {
    if (!initialDataLoaded) {
      loadUserProfile().then(() => {
        setInitialDataLoaded(true);
      });
    }
  }, [props.params]);

  // Refresh header stats (points, money spent, pending count) after accept/reject actions
  useEffect(() => {
    if (initialDataLoaded) {
      getUserDetails();
    }
  }, [refresh, initialDataLoaded]);

  // Load additional data after user profile is loaded
  useEffect(() => {
    if (initialDataLoaded) {
      fetchData();
      getUserMoneySpent();
      getUserGifts();
      getUserPurchases();
    }
  }, [
    refresh,
    giftCurrentPage,
    purchaseCurrentPage,
    moneyCurrentPage,
    initialDataLoaded,
  ]);

  useEffect(() => {
    (async () => {
      var myHeaders = new Headers();
      myHeaders.append(
        'Accept-Language',
        languageToAcceptLanguage(i18n.language),
      );
      myHeaders.append('Authorization', `Token ${getAuthToken()}`);
      myHeaders.append('Content-Type', 'application/json');

      var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow',
      };

      const res = await fetch(
        `${API_HOST}/admin-api/v1/shop-users/${
          props.params
        }/money-spent-bonuses/`,
        requestOptions,
      )
        .then(response => response.json())
        .then(result => {
          return result;
        })
        .catch(error => {
          console.log('error', error);
          return null;
        });

      if (res !== null) {
        // setSpentBonusData(res.results);

        let filterData =
          res.results &&
          res.results.map(e => {
            let myDate = moment(e.created_at).format('YYYY-MM-DD');
            e.created_at = myDate;

            return e;
          });

        let resData = [];
        if (res.results && res.results.length > 0) {
          resData = res.results.map(e => {
            e.money_spent =
              e.level_awards.length > 0 ? e.level_awards[0].level_name : '';
            e.gift_name = e.discount === null ? e.points : e.discount;
            return e;
          });
        }

        setSpentBonusData(resData);

        // let myDate = moment(e.updated_at).format('YYYY-MM-DD');
      }

      // const users = await fetchUsers();
      // setUsers(users);
    })();
  }, [setSpentBonusData, props]);

  const getuseData = async val => {
    setColumn(val);
  };

  return (
    <ContentWrapper
      breadcrumb={[
        {title: t('sidebar.menuItems.shopUsers'), link: '/shop-users'},
        {
          title: userProfileLoading
            ? t('shopUserDetail.loadingUser') || 'Loading...'
            : `${userdata?.user?.first_name || ''} ${
                userdata?.user?.last_name || ''
              }`.trim() || 'User Detail',
          link: '#',
        },
      ]}
      removeShopUser={true}
      hasSearch={false}
      onButtonOneClick={RemoveUser}
      onButtonTwoClick={openModal}>
      <div className="flex flex-col w-full">
        <div
          className="bg-tableHeaderBg"
          style={{
            height: '75px',
            borderRadius: '10px',
            marginBottom: '20px',
            width: '100%',
            display: 'flex',
            textAlign: 'center',
          }}>
          {userProfileLoading ? (
            // Loading skeleton for user profile header
            <>
              <div
                style={{width: '10%', padding: '15px'}}
                className="flex items-center">
                <div
                  className="user-avatar bg-gray-300 animate-pulse"
                  style={{
                    borderRadius: '50%',
                    width: '45px',
                    height: '45px',
                  }}
                />
              </div>
              {[...Array(6)].map((_, index) => (
                <div key={index} style={{width: '15%', padding: '15px'}}>
                  <div className="h-4 bg-gray-300 animate-pulse rounded mb-2" />
                  <div className="h-6 bg-gray-300 animate-pulse rounded" />
                </div>
              ))}
            </>
          ) : (
            // Actual user profile content
            <>
              <div
                style={{width: '10%', padding: '15px'}}
                className="flex items-center">
                {userdata?.user?.profile?.profile_image ? (
                  <img
                    src={getAbsoluteImageUrl(
                      userdata?.user?.profile?.profile_image,
                    )}
                    className="user-avatar"
                    alt="User avatar"
                  />
                ) : (
                  <img
                    src="https://cdn-icons-png.flaticon.com/512/1077/1077063.png"
                    className="user-avatar"
                    alt="User avatar"
                  />
                )}
              </div>
              <div style={{width: '15%', padding: '15px'}}>
                <h5>{t('shopUserDetail.pending')}</h5>
                <p>
                  {userdata?.pending_count === null
                    ? '0'
                    : userdata.pending_count}
                </p>
              </div>
              <div style={{width: '15%', padding: '15px'}}>
                <h5>{t('shopUserDetail.purchased')}</h5>
                <p>
                  {userdata?.purchase_count === null
                    ? '0'
                    : userdata.purchase_count}
                </p>
              </div>
              <div style={{width: '15%', padding: '15px'}}>
                <h5>{t('shopUserDetail.level')}</h5>
                <p>{userdata && userdata.selected_level}</p>
              </div>
              <div style={{width: '15%', padding: '15px'}}>
                <h5>{t('shopUserDetail.points')}</h5>
                <p>{userdata?.points === null ? '0' : userdata.points}</p>
              </div>
              <div style={{width: '15%', padding: '15px'}}>
                <h5>{t('shopUserDetail.spent')}</h5>
                <p>
                  {userdata?.total_spent === null ? '0' : userdata.total_spent}
                </p>
              </div>
              <div style={{width: '15%', padding: '15px'}}>
                <h5>{t('shopUserDetail.referral')}</h5>
                <p>{userdata?.referral_code}</p>
              </div>
            </>
          )}
        </div>

        <div
          style={{
            marginBottom: '20px',
            display: 'flex',
            justifyContent: 'space-between',
          }}>
          <h4>{t('shopUserDetail.userActivity')}</h4>
          <h4>
            {userProfileLoading ? (
              <span className="bg-gray-300 animate-pulse rounded h-6 w-32 inline-block" />
            ) : (
              `${t(
                'shopUserDetail.referralCode',
              )} : ${userdata?.referral_code || 'N/A'}`
            )}
          </h4>
        </div>
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={customStyles}>
          <form>
            <h2 className="mb-4">{t('shopUserDetail.moneySpent')}</h2>
            <Input
              value={amount}
              onChange={e => setAmount(e.target.value)}
              label={t('shopUserDetail.addAmount')}
            />
            <Input
              value={note}
              onChange={e => setNote(e.target.value)}
              label={t('shopUserDetail.addNote')}
            />
            <Button
              label={t('shopUserDetail.save')}
              onClick={MoneySpent}
              type="submit"
            />
          </form>
        </Modal>
        <Modal
          isOpen={bonusmodalIsOpen}
          onRequestClose={closebonusModal}
          style={customStyles}>
          <form>
            <h2>Give Bonus</h2>
            <Input
              // work here
              value={moneyspent}
              onChange={e => setMoneySpent(e.target.value)}
              label="Money Spent"
              placeHolderIs={'Please Enter A Number'}
            />
            <Input
              value={discount}
              onChange={e => setDiscount(e.target.value)}
              label="Discount"
              placeHolderIs={'Please Enter A Number'}
            />
            <Input
              value={points}
              type="number"
              onChange={e => setPoint(e.target.value)}
              label="Points"
              placeHolderIs={'Please Enter A Number'}
            />
            <Select
              className="mb-4"
              onChange={giftgetdata}
              options={productoption}
              // value={gift}
              defaultValue={1}
            />
            <Button label="Save" onClick={GiveBouns} type="submit" />
          </form>
        </Modal>
        <div
          style={{
            height: '45px',
            borderRadius: '10px',
            width: '100%',
            display: 'flex',
            textAlign: 'center',
            justifyContent: 'space-between',
          }}>
          <div style={{display: 'flex'}}>
            <div
              className={columns === '1' ? 'bg-tableHeaderBg p-2' : 'p-2'}
              style={{borderRadius: '10px 10px 0px 0px'}}
              onClick={() => getuseData('1')}>
              Reward points ({rewardTotal})
            </div>
            <div
              className={columns === '2' ? 'bg-tableHeaderBg p-2' : 'p-2'}
              style={{borderRadius: '10px 10px 0px 0px'}}
              onClick={() => getuseData('2')}>
              Gifts ({giftTotal})
            </div>
            <div
              className={
                columns === '3' ? 'bg-tableHeaderBg p-2 ml-1' : 'p-2 ml-1'
              }
              style={{borderRadius: '10px 10px 0px 0px'}}
              onClick={() => getuseData('3')}>
              Loyalty points purchases ({purchaseTotal})
            </div>
            <div
              className={
                columns === '4' ? 'bg-tableHeaderBg p-2 ml-1' : 'p-2 ml-1'
              }
              style={{borderRadius: '10px 10px 0px 0px'}}
              onClick={() => getuseData('4')}>
              Money spent ({moneyTotal})
            </div>
          </div>
          {columns == '4' ? (
            <Button
              type="primary"
              onClick={openModal}
              label="ADD MONEY SPENT"
            />
          ) : (
            <div style={{display: 'flex'}}>
              {/* <Button
                type="primary"
                onClick={Acceptslected}
                label="ACCEPT SELECTED"
              />
              <Button
                type="secondary"
                onClick={Rejectslected}
                label="REJECT SELECTED"
              /> */}
            </div>
          )}
          {/* Extra bonus for money spent */}
        </div>
        {columns == '1' ? (
          <>
            <Table columns={tablerewardcolumns} data={RewardData} />
            {RewardData && RewardData.length === 0 && !loading ? (
              <div>
                <p className="text-center mt-5">{t('shopUserDetail.noData')}</p>
              </div>
            ) : (
              <div>
                <div className="bg-tableHeaderBg py-2 md:flex md:justify-center gap-x-10 px-4">
                  <button
                    style={{
                      backgroundColor: '#970c24d9',
                      padding: 10,
                      color: '#fff',
                      borderRadius: 5,
                    }}
                    className={`text-xs text-center text-wine ${
                      rewardpreviousPage !== null
                        ? 'cursor-pointer'
                        : 'pointer-none'
                    }`}
                    onClick={() => {
                      setRewardCurrentPage(rewardCurrentPage - 1);
                    }}>
                    {t('shopUserDetail.showPrevious')}
                  </button>

                  <button
                    style={{
                      backgroundColor: '#970c24d9',
                      padding: 10,
                      color: '#fff',
                      borderRadius: 5,
                    }}
                    className={`text-xs text-center text-wine ${
                      rewardNextPage !== null
                        ? 'cursor-pointer'
                        : 'pointer-none'
                    }`}
                    onClick={() => setRewardCurrentPage(rewardCurrentPage + 1)}>
                    {t('shopUserDetail.showNext')}
                  </button>
                </div>
              </div>
            )}
          </>
        ) : columns == '2' ? (
          <>
            <Table columns={tablegiftcolumns} data={GiftData} />
            {GiftData && GiftData.length === 0 && !loading ? (
              <div>
                <p className="text-center mt-5">{t('shopUserDetail.noData')}</p>
              </div>
            ) : (
              <div>
                <div className="bg-tableHeaderBg py-2 md:flex md:justify-center gap-x-10 px-4">
                  <button
                    style={{
                      backgroundColor: '#970c24d9',
                      padding: 10,
                      color: '#fff',
                      borderRadius: 5,
                    }}
                    className={`text-xs text-center text-wine ${
                      giftpreviousPage !== null
                        ? 'cursor-pointer'
                        : 'pointer-none'
                    }`}
                    onClick={() => {
                      setGiftCurrentPage(giftCurrentPage - 1);
                    }}>
                    {t('shopUserDetail.showPrevious')}
                  </button>
                  <button
                    style={{
                      backgroundColor: '#970c24d9',
                      padding: 10,
                      color: '#fff',
                      borderRadius: 5,
                    }}
                    className={`text-xs text-center text-wine ${
                      giftNextPage !== null ? 'cursor-pointer' : 'pointer-none'
                    }`}
                    onClick={() => setGiftCurrentPage(giftCurrentPage + 1)}>
                    {t('shopUserDetail.showNext')}
                  </button>
                </div>
              </div>
            )}
          </>
        ) : columns == '3' ? (
          <>
            <Table columns={tablepurchasecolumns} data={PurchaseData} />
            {PurchaseData && PurchaseData.length === 0 && !loading ? (
              <div>
                <p className="text-center mt-5">{t('shopUserDetail.noData')}</p>
              </div>
            ) : (
              <div>
                <div className="bg-tableHeaderBg py-2 md:flex md:justify-center gap-x-10 px-4">
                  <button
                    style={{
                      backgroundColor: '#970c24d9',
                      padding: 10,
                      color: '#fff',
                      borderRadius: 5,
                    }}
                    className={`text-xs text-center text-wine ${
                      purchasepreviousPage !== null
                        ? 'cursor-pointer'
                        : 'pointer-none'
                    }`}
                    onClick={() => {
                      setPurchaseCurrentPage(purchaseCurrentPage - 1);
                    }}>
                    {t('shopUserDetail.showPrevious')}
                  </button>

                  <button
                    style={{
                      backgroundColor: '#970c24d9',
                      padding: 10,
                      color: '#fff',
                      borderRadius: 5,
                    }}
                    className={`text-xs text-center text-wine ${
                      purchaseNextPage !== null
                        ? 'cursor-pointer'
                        : 'pointer-none'
                    }`}
                    onClick={() =>
                      setPurchaseCurrentPage(purchaseCurrentPage + 1)
                    }>
                    {t('shopUserDetail.showNext')}
                  </button>
                </div>
              </div>
            )}
          </>
        ) : (
          <div>
            <>
              <Table columns={tablemoneysentcolumns} data={spendData} />{' '}
              {spendData && spendData.length === 0 && !loading ? (
                <div>
                  <p className="text-center mt-5">
                    {t('shopUserDetail.noData')}
                  </p>
                </div>
              ) : (
                <div>
                  <div className="bg-tableHeaderBg py-2 md:flex md:justify-center gap-x-10 px-4">
                    <button
                      style={{
                        backgroundColor: '#970c24d9',
                        padding: 10,
                        color: '#fff',
                        borderRadius: 5,
                      }}
                      className={`text-xs text-center text-wine ${
                        moneypreviousPage !== null
                          ? 'cursor-pointer'
                          : 'pointer-none'
                      }`}
                      onClick={() => {
                        setMoneyCurrentPage(moneyCurrentPage - 1);
                      }}>
                      {t('shopUserDetail.showPrevious')}
                    </button>

                    <button
                      style={{
                        backgroundColor: '#970c24d9',
                        padding: 10,
                        color: '#fff',
                        borderRadius: 5,
                      }}
                      className={`text-xs text-center text-wine ${
                        moneyNextPage !== null
                          ? 'cursor-pointer'
                          : 'pointer-none'
                      }`}
                      onClick={() => setMoneyCurrentPage(moneyCurrentPage + 1)}>
                      {t('shopUserDetail.showNext')}
                    </button>
                  </div>
                </div>
              )}
            </>
            {/* <div
                className="mb-2"
                style={{
                  justifyContent: 'space-between',
                  display: 'flex',
                  marginTop: '20px',
                }}>
                <h5>Extra bonus for money spent</h5>
                <Button
                  type="primary"
                  onClick={openbonusModal}
                  label="GIVE BONUS"
                />{' '}
              </div>
              <Table columns={tablemoneysentbounscolumns} data={spendbonusData} /> */}
          </div>
        )}

        {/* <button>
          <div className="bg-tableHeaderBg py-2">
            <p className="text-btnSecondaryText text-xs text-center">
              show next 10 results
            </p>
          </div>
        </button> */}
      </div>
    </ContentWrapper>
  );
};

export default ShopUserDetail;
